import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronRight, FaFacebookF, FaTwitter, FaInstagram, FaTiktok, FaBars} from "react-icons/fa";

import News from '../views/News.js';

import '../styles/Navbar.css';
import '../styles/Responsive.css';

function Navbar({ children }) {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [menu, setMenu] = useState('');
  const [subMenu, setSubMenu] = useState('');
  const location = useLocation();


  return (
    <div className='nav-wrapper' style={{display: 'flex', flexDirection:'column'}}>
      <div className='navbar'>
        <Link className='navbar-logo-container' to={'/'}>
            {(location.pathname == '/emarket') ?
              <img src={process.env.PUBLIC_URL + '/assets/emarket_logo_white.png'} className='navbar-logo' style={{height: '65px'}}/>

              :

              <img src={process.env.PUBLIC_URL + '/assets/nav_logo.png'} className='navbar-logo'/>
            }
        </Link>
        <div className='navbar-options'>
            <div className='navbar-options-top'>
              <Link className='navbar-option' to={'/'}>
                Home 
              </Link>
              <div className='navbar-option' onClick={() => {setMenu(menu === 'about' ? '' : 'about')}}>
                About 
                { (menu === 'about') &&
                  <div className='navbar-dropdown-option-column'>
                    <Link className='navbar-dropdown-option' to={'/about/mission'}>Mission, Vision & History</Link>
                    <Link className='navbar-dropdown-option' to={'/about/board'}>Board of Directors</Link>
                    <Link className='navbar-dropdown-option' to={'/about/secretariat'}>Secretariat</Link>
                  </div>
                }
              </div>
              <div className='navbar-option' onClick={() => {setMenu(menu === 'membership' ? '' : 'membership')}}>
                Membership
                { (menu === 'membership') &&
                  <div className='navbar-dropdown-option-column'>
                    <Link className='navbar-dropdown-option' to={'/membership/listing'}>Our Members</Link>
                    <Link className='navbar-dropdown-option' to={'/membership/categories'}>Membership Categories</Link>
                    <Link className='navbar-dropdown-option' to={'/membership/benefits'}>Membership Benefits</Link>
                    <Link className='navbar-dropdown-option' to={'/membership/working-committees'}>CANTO Working Committees</Link>
                    <Link className='navbar-dropdown-option' to={'/membership/faqs'}>Membership FAQs</Link>
                  </div>
                }
              </div>
              <div className='navbar-option' onClick={() => {setMenu(menu === 'events' ? '' : 'events')}}>
                Events
                { (menu === 'events') &&
                  <div className='navbar-dropdown-option-column'>
                    <div 
                      className='navbar-dropdown-option with-submenu' 
                      onMouseEnter={() => {setSubMenu('connect')}} 
                      onMouseLeave={() => {setSubMenu('')}}
                    >
                      <Link to={'/events/canto-connect/2'}>CANTO Connect</Link>
                      {subMenu === 'connect' && (
                        <div className='navbar-submenu'>
                          <Link className='navbar-dropdown-option' to={'/events/agm-documents'}>AGM Documents</Link>
                        </div>
                      )}
                    </div>
                    <div 
                      className='navbar-dropdown-option with-submenu' 
                      onMouseEnter={() => {setSubMenu('conference')}} 
                      onMouseLeave={() => {setSubMenu('')}}
                    >
                      <Link to={'/events/canto-conference'}>CANTO Annual Conference & Trade Exhibition</Link>
                      {subMenu === 'conference' && (
                        <div className='navbar-submenu'>
                          <Link className='navbar-dropdown-option' to={'/events/presentations'}>Presentations</Link>
                        </div>
                      )}
                    </div>
                    <Link className='navbar-dropdown-option' to={'/events/innovation-challenge'}>Innovation Challenge</Link>
                    <Link className='navbar-dropdown-option' to={'/events/canto-conversations'}>CANTO Conversations</Link>
                    <Link className='navbar-dropdown-option' to={'/events/calendar'}>Event Calendar</Link>
                  </div>
                }
              </div>
              <div className='navbar-option' onClick={() => {setMenu(menu === 'publications' ? '' : 'publications')}}>
                Publications
                { (menu === 'publications') &&
                  <div className='navbar-dropdown-option-column'>
                    <Link className='navbar-dropdown-option' to={'/publications/press-releases'}>Press Releases</Link>
                    <Link className='navbar-dropdown-option' to={'/publications/cancion'}>CANCION Magazine</Link>
                  </div>
                }
              </div>
              <Link className='navbar-option' to={'/emarket'}>E-Market</Link>
              <Link className='navbar-option' to={'/contact'}>Contact Us</Link>
              {/* <Link className='navbar-option' to={'/dashboard'}>Dashboard</Link> */}

              
              
            </div>
        </div>

        <div className='navbar-options-bottom'>
          {/* <div className='navbar-dropdown'>

            <div className='navbar-dropdown-options'>
              

              <div className='navbar-dropdown-option-column'>
                <Link className='navbar-dropdown-option header'>Publications</Link>
                <Link className='navbar-dropdown-option '>CANCION</Link>
                <Link className='navbar-dropdown-option '>Annual Report</Link>
                <Link className='navbar-dropdown-option '>Annual Directory</Link>
              </div>

              

            </div>

          </div> */}

          {/* <div className='burger-menu-container' onClick={() => {
            setMenuOpen(!isMenuOpen)
          }}>
            <FaBars size={18} color='#fff' className='burger-icon'/>
            <div className={"burger-menu " + (isMenuOpen ? 'open' : '')}>

              
              <Link className='burger-menu-option'>Publications <div className='burger-menu-option-icon'><FaChevronRight size={14} color='#2c2c2c'/></div></Link>
              <Link className='burger-menu-option' to={'/news'} onClick={() => {
                setMenuOpen(false);
              }}>Media <div className='burger-menu-option-icon'><FaChevronRight size={14} color='#2c2c2c'/></div></Link>
              <Link className='burger-menu-option' to={'/emarket'} onClick={() => {
                setMenuOpen(false);
              }}>E-market <div className='burger-menu-option-icon'><FaChevronRight size={14} color='#2c2c2c'/></div></Link>
            </div>
          </div> */}
          </div>
      </div>
      <div >{children}</div>
    </div>
  );
}

export default Navbar;
